"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _popper = _interopRequireDefault(require("popper.js"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _clickOutside = _interopRequireDefault(require("../click-outside"));

var _dom = _interopRequireDefault(require("../utils/dom"));

var _PropsType = require("./PropsType");

var _events = _interopRequireDefault(require("../utils/events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var invertKeyValues = function invertKeyValues(obj, fn) {
  return Object.keys(obj).reduce(function (acc, key) {
    var val = fn ? fn(obj[key]) : obj[key];
    acc[val] = acc[val] || [];
    acc[val].push(key);
    return acc;
  }, {});
};

var getPopperClientRect = function getPopperClientRect(popperOffsets) {
  var offsets = _objectSpread({}, popperOffsets);

  offsets.right = offsets.left + offsets.width;
  offsets.bottom = offsets.top + offsets.height;
  return offsets;
};

var customArrowOffsetFn = function customArrowOffsetFn(data) {
  var _data$placement$split = data.placement.split('-'),
      _data$placement$split2 = _slicedToArray(_data$placement$split, 2),
      placement = _data$placement$split2[0],
      placement1 = _data$placement$split2[1];

  var arrow = data.instance.options.modifiers && data.instance.options.modifiers.arrow.element;
  var reference = data.offsets.reference;
  var popper = getPopperClientRect(data.offsets.popper);
  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
  var len = isVertical ? 'height' : 'width';
  var side = isVertical ? 'top' : 'left';
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';

  var arrowSize = _dom.default.getOuterSizes(arrow)[len];

  var offsetSize = parseFloat(getComputedStyle(data.instance.popper, null).paddingLeft);
  var hashMap = {
    start: side === 'top' || side === 'left' ? reference[side] + offsetSize : reference[opSide] - offsetSize - arrowSize,
    center: reference[side] + reference[len] / 2 - arrowSize / 2,
    end: side === 'top' || side === 'left' ? reference[opSide] - offsetSize - arrowSize : reference[side] + offsetSize
  };
  var place = hashMap[placement1 || 'center'];
  var sideValue = place - popper[side];
  data.arrowElement = arrow;
  data.arrowStyles[side] = Math.floor(sideValue).toString();
  data.arrowStyles[altSide] = '';
  return data;
};

var popperInstances = new Set();

var Popper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Popper, _React$Component);

  function Popper() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Popper)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.popper = void 0;
    _this.popperNode = void 0;
    _this.reference = void 0;
    _this.arrowRef = void 0;
    _this.enterTimer = void 0;
    _this.leaveTimer = void 0;
    _this.state = {
      show: false,
      direction: _this.props.direction,
      arrowRef: null,
      mounted: false,
      isPending: false,
      animationState: 'leave'
    };

    _this.handleOpen = function () {
      var _this$props = _this.props,
          direction = _this$props.direction,
          hasArrow = _this$props.hasArrow,
          arrowPointAtCenter = _this$props.arrowPointAtCenter;
      var reference = _this.reference;
      var popperNode = _this.popperNode;

      if (!popperNode) {
        return;
      }

      if (_this.popper) {
        _this.destroy();
      }

      _this.popper = new _popper.default(reference, popperNode, {
        placement: _PropsType.directionMap[direction],
        modifiers: {
          preventOverflow: {
            boundariesElement: 'window'
          },
          computeStyle: {
            gpuAcceleration: false
          },
          arrow: _objectSpread({
            enabled: Boolean(_this.arrowRef),
            element: _this.arrowRef
          }, !(hasArrow && arrowPointAtCenter) && {
            fn: customArrowOffsetFn
          })
        },
        onCreate: _this.handlePopperUpdate,
        onUpdate: _this.handlePopperUpdate
      });

      _events.default.on(_this.popperNode, 'webkitAnimationEnd', _this.animationEnd);

      _events.default.on(_this.popperNode, 'animationend', _this.animationEnd);

      _this.enter();

      popperInstances.add(_this.popper);
    };

    _this.animationEnd = function (e) {
      e.stopPropagation();
      var animationState = _this.state.animationState;
      var destroy = _this.props.destroy;

      if (animationState === 'leave') {
        _this.setState(_objectSpread({
          show: false,
          isPending: false
        }, destroy && {
          mounted: false
        }), function () {
          _this.destroy();

          _this.props.onVisibleChange(false);
        });
      } else {
        // this.setState({ mounted: true });
        _this.props.onVisibleChange(true);
      }
    };

    _this.handlePopperUpdate = function (data) {
      _this.setTransformOrigin();

      if (data.placement !== _this.state.direction) {
        _this.setState({
          direction: invertKeyValues(_PropsType.directionMap)[data.placement]
        });
      }
    };

    _this.handleClose = function () {
      if (!_this.popper) {
        return;
      }

      _this.leave();
    };

    _this.handleClick = function (event) {
      var trigger = _this.props.trigger;
      var show = _this.state.show;
      if (trigger === 'contextMenu') event.preventDefault();

      _this.setState({
        mounted: true
      }, function () {
        if (!show) {
          _this.handleOpen();
        } else {
          _this.handleClose();
        }
      });
    };

    _this.handleEnter = function (event) {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          mouseEnterDelay = _this$props2.mouseEnterDelay;
      var childrenProps = children.props;

      if (_react.default.isValidElement(children) && event.type === 'mouseover' && childrenProps.onMouseOver) {
        childrenProps.onMouseOver(event);
      }

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);
      _this.enterTimer = setTimeout(function () {
        _this.setState({
          mounted: true
        }, _this.handleOpen);
      }, mouseEnterDelay);
    };

    _this.handleLeave = function (event) {
      var _this$props3 = _this.props,
          children = _this$props3.children,
          mouseLeaveDelay = _this$props3.mouseLeaveDelay;
      var childrenProps = children.props;

      if (_react.default.isValidElement(children) && event.type === 'blur' && childrenProps.onBlur) {
        childrenProps.onBlur(event);
      }

      if (_react.default.isValidElement(children) && event.type === 'mouseleave' && childrenProps.onMouseLeave) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);
      _this.leaveTimer = setTimeout(function () {
        _this.handleClose();
      }, mouseLeaveDelay);
    };

    return _this;
  }

  _createClass(Popper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
          direction = _this$props4.direction,
          visible = _this$props4.visible;

      if (visible && (prevProps.visible !== visible || prevProps.direction !== direction)) {
        this.handleOpen();
      }

      if (prevProps.visible !== visible && !visible) {
        this.handleClose();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.popperNode) {
        _events.default.off(this.popperNode, 'webkitAnimationEnd', this.animationEnd);

        _events.default.off(this.popperNode, 'animationend', this.animationEnd);
      }

      this.destroy();
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: "getPopperDomNode",
    value: function getPopperDomNode() {
      return this.popperNode;
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      var getContainer = this.props.getContainer;

      if (getContainer) {
        if (typeof getContainer === 'function') {
          return getContainer();
        }

        if (_typeof(getContainer) === 'object' && getContainer instanceof HTMLElement) {
          return getContainer;
        }
      }

      return document.body;
    }
  }, {
    key: "setTransformOrigin",
    value: function setTransformOrigin() {
      var placementMap = {
        top: 'bottom',
        bottom: 'top',
        left: 'right',
        right: 'left'
      };
      var placement = this.popperNode.getAttribute('x-placement').split('-')[0];
      var origin = placementMap[placement];
      this.popperNode.style.transformOrigin = ['top', 'bottom'].indexOf(placement) > -1 ? "center ".concat(origin) : "".concat(origin, " center");
    }
  }, {
    key: "enter",
    value: function enter() {
      this.setState({
        show: true,
        isPending: true,
        animationState: 'enter'
      });
    }
  }, {
    key: "leave",
    value: function leave() {
      this.setState({
        show: false,
        isPending: true,
        animationState: 'leave'
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.popper) {
        this.popper.destroy();
        popperInstances.delete(this.popper);
        this.popper = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames,
          _this2 = this;

      var _this$props5 = this.props,
          children = _this$props5.children,
          content = _this$props5.content,
          prefixCls = _this$props5.prefixCls,
          style = _this$props5.style,
          className = _this$props5.className,
          trigger = _this$props5.trigger,
          hasArrow = _this$props5.hasArrow,
          animationType = _this$props5.animationType,
          animationDuration = _this$props5.animationDuration;
      var _this$state = this.state,
          direction = _this$state.direction,
          mounted = _this$state.mounted,
          animationState = _this$state.animationState,
          isPending = _this$state.isPending;

      var child = _react.default.createElement("div", {
        className: "".concat(prefixCls, "__inner")
      }, children);

      var innerCls = (0, _classnames2.default)(className, "".concat(prefixCls, "__wrapper"), "".concat(prefixCls, "--").concat(direction), (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "--hidden"), animationState === 'leave'), _defineProperty(_classnames, "za-".concat(animationType, "-").concat(animationState), isPending), _classnames));
      var childrenProps = {
        ref: function ref(node) {
          _this2.reference = node;
        }
      };
      var event = {};

      if (trigger === 'click') {
        childrenProps.onClick = this.handleClick;
      }

      if (trigger === 'contextMenu') {
        childrenProps.onContextMenu = this.handleClick;
      }

      if (trigger === 'hover') {
        childrenProps.onMouseOver = this.handleEnter;
        childrenProps.onMouseLeave = this.handleLeave;
        event.onMouseOver = this.handleEnter;
        event.onMouseLeave = this.handleLeave;
      }

      if (trigger === 'focus') {
        childrenProps.onFocus = this.handleClick; // childrenProps.onBlur = this.handleLeave;
      }

      var childElement = _react.default.cloneElement(child, childrenProps);

      var toolTip = _react.default.createElement(_clickOutside.default, {
        onClickOutside: this.handleClose,
        ignoredNode: this.reference,
        className: "popper-container",
        disabled: trigger === 'manual'
      }, _react.default.createElement("div", _extends({
        role: "tooltip",
        style: {
          position: 'absolute',
          animationDuration: "".concat(animationDuration, "ms")
        },
        className: innerCls,
        ref: function ref(node) {
          _this2.popperNode = node;
        }
      }, event), _react.default.createElement("div", {
        className: "".concat(prefixCls, "__content")
      }, content), hasArrow && _react.default.createElement("span", {
        className: "".concat(prefixCls, "__arrow"),
        ref: function ref(el) {
          _this2.arrowRef = el;
        }
      })));

      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
        className: prefixCls,
        style: style
      }, mounted && (0, _reactDom.createPortal)(toolTip, this.getContainer()), childElement));
    }
  }], [{
    key: "update",
    value: function update() {
      popperInstances.forEach(function (popperInstance) {
        return popperInstance.scheduleUpdate();
      });
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if ('visible' in props && props.trigger === 'manual') {
        return _objectSpread({}, state, {
          show: props.visible
        }, props.visible && {
          mounted: true
        });
      }

      return null;
    }
  }]);

  return Popper;
}(_react.default.Component);

Popper.propTypes = {
  prefixCls: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  visible: _propTypes.default.bool,
  destroy: _propTypes.default.bool,
  hasArrow: _propTypes.default.bool,
  arrowPointAtCenter: _propTypes.default.bool,
  trigger: _propTypes.default.oneOf(['click', 'hover', 'focus', 'manual', 'contextMenu']),
  content: _propTypes.default.node,
  animationType: _propTypes.default.string,
  animationDuration: _propTypes.default.number,
  direction: _propTypes.default.oneOf(['top', 'topLeft', 'topRight', 'right', 'rightTop', 'rightBottom', 'bottom', 'bottomLeft', 'bottomRight', 'left', 'leftTop', 'leftBottom']),
  mouseEnterDelay: _propTypes.default.number,
  mouseLeaveDelay: _propTypes.default.number,
  onVisibleChange: _propTypes.default.func
};
Popper.defaultProps = {
  prefixCls: 'za-popper',
  hasArrow: false,
  destroy: true,
  arrowPointAtCenter: false,
  trigger: /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent) ? 'click' : 'hover',
  direction: 'top',
  mouseEnterDelay: 100,
  mouseLeaveDelay: 100,
  visible: false,
  content: '',
  animationType: 'zoom-fade',
  animationDuration: 200,
  onVisibleChange: function onVisibleChange() {}
};
var _default = Popper;
exports.default = _default;